import { translate } from 'react-i18next';

export default { core: translate('core') };



// WEBPACK FOOTER //
// ./src/helpers/ml.helper.js